import { render, staticRenderFns } from "./TimelineItemDialog.vue?vue&type=template&id=4c329565&scoped=true"
import script from "./TimelineItemDialog.vue?vue&type=script&lang=js"
export * from "./TimelineItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c329565",
  null
  
)

export default component.exports